<template>
    <div id="new">
        <div class="ui segment">
            <div class="ui horizontal divider">
                <h3>
                    <i class="clipboard icon"></i>
                    {{ $t('ui.page_titles.new_provider_contract') }}
                </h3>
            </div>
            <div class="ui form">
                <div class="fields">
                    <div class="eight wide required field" data-column="name">
                        <label>{{ $t('models.attributes.customer_contracts.name') }}</label>
                        <input
                            type="text"
                            v-model="contract.name">
                    </div>
                    <div class="eight wide required field column" data-column="number">
                        <label>{{ $t('models.attributes.customer_contracts.number') }}</label>
                        <input
                            type="text"
                            v-model="contract.number">
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide required field" data-column="carrier_class">
                        <label>{{ $t('models.attributes.customer_contracts.carrier_class') }}</label>
                        <select v-if="$store.state.provider.node" class="ui dropdown" v-dropdown v-model="contract.carrier_class">
                            <option value="">{{ $t('ui.general.please_select') }}</option>
                            <option :value="$store.state.provider.node.carrier_class">{{ $store.state.provider.node.company_short_name }}</option>
                            <option value="Carrier::LMSProxy">自動轉運</option>
                        </select>
                        <div v-else class="ui inline active loader"></div>
                    </div>
                    <div class="eight wide field column">
                        <label>{{ $t('models.attributes.customer_contracts.proxy_contract') }}</label>
                        <select v-if="current_store.provider_contracts" class="ui dropdown" v-dropdown v-model="contract.proxy_contract_identity">
                            <option value="">{{ $t('ui.general.please_select') }}</option>
                            <option v-for="provider_contract in current_store.provider_contracts" :value="provider_contract.identity">{{ provider_contract.name }}</option>
                        </select>
                        <div v-else class="ui inline active loader"></div>
                    </div>
                </div>
                <div class="ui divider"></div>
                <div class="fields">
                    <div class="eight wide field">
                        <div class="ui checkbox" v-checkbox>
                            <input type="checkbox" tabindex="0" class="hidden" v-model="contract.is_automated_fetch_status">
                            <label>
                                是否自動同步貨況
                            </label>
                        </div>
                    </div>
                    <div class="eight wide field">
                        <div class="ui checkbox" v-checkbox>
                            <input type="checkbox" tabindex="0" class="hidden" v-model="contract.is_automated_send_data">
                            <label>
                                是否自動傳送EDI
                            </label>
                        </div>
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide field" :class="{'required': contract.is_automated_fetch_status}">
                        <label>自動同步貨況設定</label>
                        <input
                            type="text"
                            :disabled="!contract.is_automated_fetch_status"
                            v-model="contract.fetch_status_cron">
                        <p v-if="contract.fetch_status_cron" v-for="cron in human_readable_cron(contract.fetch_status_cron)"><i>會於 {{ cron }} 執行</i></p>
                    </div>
                    <div class="eight wide field column" :class="{'required': contract.is_automated_send_data}">
                        <label>自動傳送EDI設定</label>
                        <input
                            type="text"
                            :disabled="!contract.is_automated_send_data"
                            v-model="contract.send_data_cron">
                        <p v-if="contract.send_data_cron" v-for="cron in human_readable_cron(contract.send_data_cron)"><i>會於 {{ cron }} 執行</i></p>
                    </div>
                </div>
            </div>
            <div class="ui horizontal divider">
                <h3>
                    <i class="code icon"></i>
                    {{ $t('ui.pages.customer_contracts.additional_information') }}
                </h3>
            </div>
            <div class="ui form">
                <div class="fields">
                    <div class="sixteen wide field">
                        <label>{{ $t('models.attributes.customer_contracts.note') }}</label>
                        <textarea v-model="contract.note" rows="4"></textarea>
                    </div>
                    <div class="sixteen wide required field">
                        <label>{{ $t('models.attributes.customer_contracts.third_party_api_data') }}</label>
                        <codemirror
                            v-model="contract.third_party_api_data"
                            :options="code_mirror_options">
                        </codemirror>
                    </div>
                </div>
            </div>

            <div class="ui divider"></div>

            <div class="right floated">
                <a href="#" @click.prevent="$router.go(-1)" class="ui button">
                    {{ $t('ui.general.back') }}
                </a>
                <a href="#" v-if="!is_loading" @click.prevent="create_contract()" class="ui blue button">
                    {{ $t('ui.general.create') }}
                </a>
                <a href="#" v-else class="ui blue button">
                    {{ $t('ui.general.creating') }}...
                </a>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import CronParser from 'cron-parser'
import Validator from '@toolbox/validator/main.js'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/mode/javascript/javascript.js'

export default {
    name: "ProviderCustomersContractsNew",
    mixins: [
        Validator
    ],
    props: {
    },
    data() {
        return {
            is_loading: false,
            contract: {
                customer_identity: this.$route.params.customer_identity,
                third_party_api_data: "{}"
            },
            code_mirror_options: {
                tabSize: 4,
                smartIndent: true,
                mode: "application/json",
                theme: "base16-dark",
                lineNumbers: true,
                line: true,
            }
        }
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        human_readable_cron(cron_string) {
            try {
                var interval = CronParser.parseExpression(cron_string, this.cron_parser_options)
                var crons = []
                crons.push(moment(interval.next().toString()).locale("zh-tw").format("lll"))
                crons.push(moment(interval.next().toString()).locale("zh-tw").format("lll"))
                crons.push(moment(interval.next().toString()).locale("zh-tw").format("lll"))
                return crons
            } catch (e) {
                console.log(e)
            }
        },
        create_contract() {
            if (this.valid()) {
                this.is_loading = true

                // this.contract.third_party_api_data = JSON.stringify(this.third_party_api_data)
                var params = this.contract
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_contracts_create).parse()

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success("建立客戶合約成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.contracts')
                            })
                        )
                        this.is_loading = false
                        this.$router.push({name: 'provider_customers'})
                    } else {
                        // this.$noty.error("建立客戶合約失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.contracts')
                            })
                        )
                        this.is_loading = false
                    }
                })
                .catch(error => {
                    // this.$noty.error("建立客戶合約失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.contracts')
                        })
                    )
                    this.is_loading = false
                })
            }
        }
    },
    validator: {
        target: "contract",
        localize_key: "contracts",
        input_alert: true,
        attributes: [
            {
                name: "name",
                required: true
            },
            {
                name: "number",
                required: true
            },
            {
                name: "carrier_class",
                required: true
            }
        ]
    },
    computed: {
        current_store() {
            return this.$store.state.provider.customers_module
        }
    },
    components: {
        codemirror
    }
}
</script>

<style lang="scss">
.ui.horizontal.divider:after, .ui.horizontal.divider:before {
    top: 0;
}
</style>
